"use strict";
/** @module BryxApi.SupportApi */
Object.defineProperty(exports, "__esModule", { value: true });
/** TestingToolkitMixin class */
var TestingToolkitMixin = /** @class */ (function () {
    function TestingToolkitMixin() {
    }
    /**
     * removeClientEULA
     * @param clientId
     * @param callback
     */
    TestingToolkitMixin.prototype.removeClientEULA = function (clientId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.del("/clients/" + clientId + "/eula", null, this.unauthenticatedCallback(wrappedCallback));
    };
    return TestingToolkitMixin;
}());
exports.default = TestingToolkitMixin;
//# sourceMappingURL=TestingToolkitMixin.js.map